import { OperationsData, Roles } from "../../auth/roles";
import type { AreaRoute } from "./areaRoute";
import { lazyPage } from "../../lib/lazyPage";
const FloorCommandPage = lazyPage(() => import("../floor/FloorCommandPage"), "FloorCommandPage");
const KanbanPage = lazyPage(() => import("../floor/KanbanPage"), "KanbanPage");

export { FloorCommandPage, KanbanPage };

// Same readers as the API policy (OperationsData) plus the wall display, which shows it read-only (D-O76).
const FloorCommandReaders = [...OperationsData, Roles.WallDisplay] as const;

/** Floor area (Gate B, D-O76): Kanban per shop, dispatch lists, Floor Command. Owned by agent kanban-dispatch; the integrator wires this list into App.tsx and adds the hub tabs. */
export const floorRoutes: AreaRoute[] = [
  { path: "/shop-floor/kanban", element: <KanbanPage />, allow: OperationsData },
  { path: "/shop-floor/kanban/:shop", element: <KanbanPage />, allow: OperationsData },
  { path: "/floor-command", element: <FloorCommandPage />, allow: FloorCommandReaders }
];
